import React, { Component } from "react";
import { Link } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import DehazeIcon from "@material-ui/icons/Dehaze";
import ClearSharpIcon from "@material-ui/icons/ClearSharp";
import ReceiptSharpIcon from "@material-ui/icons/ReceiptSharp";
import ArrowBackSharpIcon from "@material-ui/icons/ArrowBackSharp";
import NavigateNextSharpIcon from "@material-ui/icons/NavigateNextSharp";
import {
	PiHouse, PiUsers, PiTreeStructure, PiUserList, PiCalendarBlank,
	 PiHeartbeat, PiMegaphone, PiShapes, PiGlobe, PiChartLine, PiDetective, PiLineSegments, PiInfo, PiList
} from "react-icons/pi";
import { getCookie } from "../../function";
import logo from "../../assets/threatcop.png";
import RespLogo from "../../assets/mini_logo.png";
import LaunchModal from "../../component/launch-modal/launch-modal";
import axios from '../../axios';

import "./sidebar.css";
import { featuresObj } from "../../globalData";
import {  OverlayTrigger, Tooltip } from "react-bootstrap";
import ProductUpdateModal from "../../component/product-update-modal";
export default class SideBar extends Component {
	constructor(props) {
		super(props);
		this.isNewClient = getCookie('isNewClient');
		this.state = {
			myWindow: null,
			showModal: false,
			activeAttachment: false,
			userType: getCookie("userType"),
			billingType: getCookie("billingType"),
			accessLevel: getCookie("accessLevel"),

			activeClass: this.props.activeClass,
			activeSubClass: this.props.activeSubClass,

			activeCollapse1: this.props.activeClass === "department",
			activeCollapse2: this.props.activeClass === "reports",
			activeCollapse3: this.props.activeClass === "iam",
			activeCollapse4: this.props.activeClass === "settings",
			activeCollapse5: this.props.activeClass === "schedule",
			activeCollapse6: this.props.activeClass === "userandgroup",
			activeCollapseReports: this.props.activeSubClass === "analytics" ||
				this.props.activeSubClass === "clickreports" ||
				this.props.activeSubClass === "breachincident" ||
				this.props.activeSubClass === "repeatoffender", // Add this
			evsFeature: featuresObj['employee-vulnerability-score'],
			hackRecordFeature: featuresObj['hack-record'],
			permissibleActionsIAM: {},
			hasAnyReportPermission: false,
			showProductUpdateModal: false,
		};
	}

	componentDidUpdate = (prevProps) => {
		if (
			this.props.activeClass !== prevProps.activeClass ||
			this.props.activeSubClass !== prevProps.activeSubClass
		) {
			this.setState({
				activeClass: this.props.activeClass,
				accessLevel: getCookie("accessLevel"),
				activeSubClass: this.props.activeSubClass,
			});
		}
		if (this.props.isPackageFetched !== prevProps.isPackageFetched && this.props.isPackageFetched) {
			this.setState({
				evsFeature: featuresObj['employee-vulnerability-score'],
				hackRecordFeature: featuresObj['hack-record']
			})
		}
	};

	componentDidMount = () => {
		this.loadPermissibleActions();
		if (this.props.isPackageFetched) {
			this.setState({
				evsFeature: featuresObj['employee-vulnerability-score'],
				hackRecordFeature: featuresObj['hack-record']
			})
		}
	}

	showHandle = () => {
		this.setState({ showModal: !this.state.showModal });
	};

	backToAdmin = () => {
		if (getCookie('TAC_URL') && getCookie('isTAC'))
			window.location = getCookie('TAC_URL');
	}
	loadPermissibleActions = async () => {
		try {
			let permissibleActions = await axios.post('/api/iam-user/permissions', {
				actions: ['user-and-department-read', 'campaign-read', 'campaign-template-read', 'campaign-analytics-report', 'campaign-clicks-report', 'campaign-time-spend-report', 'campaign-breach-incident-report', 'campaign-repeat-offenders-report',
					'evs-read', 'hack-record-result', 'report-read'
				]
			});
			this.setState({
				permissibleActionsIAM: permissibleActions.data.permissibleObj,
				hasAnyReportPermission:
					permissibleActions.data.permissibleObj['campaign-analytics-report'] ||
					permissibleActions.data.permissibleObj['campaign-breach-incident-report'] ||
					permissibleActions.data.permissibleObj['campaign-clicks-report'] ||
					permissibleActions.data.permissibleObj['campaign-time-spend-report'] ||
					permissibleActions.data.permissibleObj['campaign-repeat-offenders-report'] ||
					permissibleActions.data.permissibleObj['report-read']
			});
		} catch (error) {
			console.log("Error occured while fetching permissibleActionsIAM: ", error);
		}
	}

	render() {
		return (
			<div className={this.props["sidebar"] ? "leftbar" : "leftbar shrink"}>
				<div className="nav-bar">
					<div className="sidebar-logo">
						<div>
							<Link to="/home" className="logo">
								{" "}
								<img src={logo} alt=""></img>{" "}
							</Link>
							<Link to="/home" className="miniLogo d-none">
								{" "}
								<img src={RespLogo} alt=""></img>{" "}
							</Link>
						</div>
						<div className="mini-sidebar" onClick={(e) => this.props.sideBarFun()}>
							{this.props.show ? (
								<PiList></PiList>
							) : (
								<ClearSharpIcon></ClearSharpIcon>
							)}
						</div>
					</div>
					{getCookie('isTAC') ?
						<div className="backArrow" onClick={this.backToAdmin}>
							<ArrowBackSharpIcon />
							<span>Threatcop Admin</span>
						</div> : null
					}

					
					<ul className="sidebar-list">
					
						<span className="sbheading">Main Menu</span>
						<li
							className={
								this.state.activeClass === "dashboard" ||
									this.state.activeClass === "home"
									? "active"
									: ""
							}
						>
							<Link to="/dashboard">
								<PiHouse className="icon" />
								<span>Dashboard</span>{" "}
							</Link>
						</li>
						<OverlayTrigger
							placement="top"
							overlay={

								!this.state.permissibleActionsIAM['report-read']
									? (<Tooltip id="top">You don't have permission to access</Tooltip>)
									: (<Tooltip id="top" className="d-none"></Tooltip>)
							}
						>
							<div style={{ cursor: this.state.permissibleActionsIAM['report-read'] ? "pointer" : "not-allowed" }}>
								<li
									className={
										this.state.activeClass === "reports" ||
											this.state.activeClass === "home"
											? "active"
											: ""
									}
								>
									{(this.state.permissibleActionsIAM['report-read']) ? (
										<Link to={this.state.permissibleActionsIAM['report-read'] ? "/reports" : "#"}>
											<PiChartLine className="icon" />
											<span>Reports</span>
										</Link>
									) : (
										<Link
											to={"#"}
											style={{
												cursor: "not-allowed",
												opacity: 0.6,
												textDecoration: "none"
											}}
											onClick={(e) => {
												e.preventDefault();
											}}
										>
											<PiChartLine className="icon" />
											<span>Reports</span>{" "}
										</Link>
									)}
								</li>

							</div>
						</OverlayTrigger>


						<Accordion
							className="sub-menu"
							defaultActiveKey={
								this.state.activeClass === "department" ? "0" :
									this.state.activeClass === "reports" ? "1" :
										this.state.activeClass === "iam" ? "2" :
											this.state.activeClass === "schedule" ? "4" :
												this.state.activeClass === "settings" ? "3" : "-1"
							}
						>
							<Accordion.Toggle
								eventKey="4"
								onClick={(e) =>
									this.setState({
										activeCollapse5: !this.state.activeCollapse5,
										activeCollapse1: false,
										activeCollapse2: false,
										activeCollapse3: false,
										activeCollapse4: false,
									})
								}
								className={
									this.state.activeCollapse5
										? "activeCollapse"
										: "deactiveCollapse"
								}
							>
								<PiCalendarBlank className="icon" />
								<span>
									Schedule
									<NavigateNextSharpIcon className="down-arrow" />
								</span>
							</Accordion.Toggle>
							<Accordion.Collapse className="accordion-li" eventKey="4">
								<div>
									<li className={this.state.activeSubClass === "campaigns" ? "active" : ""}>
										<Link to="/schedule/campaigns">
											<span >
												<PiMegaphone className="icon" />
												<span className="respcontNone">Report Schedular</span>
											</span>
										</Link>
									</li>
									<li
										className={this.state.activeClass === "calendar" ? "active" : ""}
									>
										<Link to="/calendar">
											<PiCalendarBlank className="icon" />
											<span>Calendar</span>
										</Link>
									</li>
								</div>
							</Accordion.Collapse>
						</Accordion>

						<span className="sbheading">Assessment</span>

						<OverlayTrigger
							placement="top"
							overlay={

								!this.state.permissibleActionsIAM['campaign-read']
									? (<Tooltip id="top">You don't have permission to access</Tooltip>)
									: (<Tooltip id="top" className="d-none"></Tooltip>)
							}
						>
							<div style={{ cursor: this.state.permissibleActionsIAM['campaign-read'] ? "pointer" : "not-allowed" }}>
								<li
									className={this.state.activeClass === "campaign" ? "active" : ""}
								>

									<Link to={this.state.permissibleActionsIAM['campaign-read'] ? "/campaign" : "#"}>
										<PiMegaphone className="icon" />
										 <span>Campaigns <sup className="new_sup">*New</sup></span>{" "}
									</Link>
								</li>
							</div>
						</OverlayTrigger>
						<OverlayTrigger
							placement="top"
							overlay={

								!this.state.permissibleActionsIAM['campaign-template-read']
									? (<Tooltip id="top">You don't have permission to access</Tooltip>)
									: (<Tooltip id="top" className="d-none"></Tooltip>)
							}
						>
							<div style={{ cursor: this.state.permissibleActionsIAM['campaign-template-read'] ? "pointer" : "not-allowed" }}>
								<li
									className={this.state.activeClass === "templates" ? "active" : ""}
								>
									<Link to={this.state.permissibleActionsIAM['campaign-template-read'] ? "/templates" : "#"}>
										<PiShapes className="icon" />
										<span>Templates</span>
									</Link>
								</li>
							</div>
						</OverlayTrigger>
						<OverlayTrigger
							placement="top"
							overlay={

								!this.state.permissibleActionsIAM['campaign-read']
									? (<Tooltip id="top">You don't have permission to access</Tooltip>)
									: (<Tooltip id="top" className="d-none"></Tooltip>)
							}
						>
							<div style={{ cursor: this.state.permissibleActionsIAM['campaign-template-read'] ? "pointer" : "not-allowed" }}>
								<li
									className={this.state.activeClass === "landing-url" ? "active" : ""}
								>
									<Link to={this.state.permissibleActionsIAM['campaign-template-read'] ? "/landing-url" : "#"}>
										<PiGlobe className="icon" />
										<span>Landing URL</span>
									</Link>
								</li>
							</div>
						</OverlayTrigger>


						<span className="sbheading">Security Insights</span>

						{this.state.billingType === "Threatcop" || (this.state.billingType === "AppSumo" && this.state.accessLevel > 2) ? (
							<OverlayTrigger
								placement="top"
								overlay={
									this.state.evsFeature ? (
										!this.state.permissibleActionsIAM['evs-read'] ? (
											<Tooltip id="top">You don't have permission to access</Tooltip>
										) : (
											<Tooltip id="top" className="d-none" />
										)
									) : (
										<Tooltip id="top">Upgrade your plan</Tooltip>
									)
								}
							>
								<li
									className={`${this.state.activeClass === "evs" ? "active" : ""}`}
								>
									{(this.state.evsFeature && this.state.permissibleActionsIAM['evs-read']) ? (
										<Link to="/evs">
											<PiHeartbeat className="icon" />
											<span>EVS</span>
										</Link>
									) : (
										<Link
											to={(this.state.evsFeature && this.state.permissibleActionsIAM['evs-read']) ? "/evs" : "#"}
											style={{
												cursor: (this.state.evsFeature && this.state.permissibleActionsIAM['evs-read']) ? "pointer" : "not-allowed",
												opacity: (this.state.evsFeature && this.state.permissibleActionsIAM['evs-read']) ? 1 : 0.6,
												textDecoration: "none"
											}}
											onClick={(e) => {
												if (!(this.state.evsFeature && this.state.permissibleActionsIAM['evs-read'])) {
													e.preventDefault();
												}
											}}
										>
											<PiHeartbeat className="icon" />
											<span>EVS</span>
										</Link>
									)}
								</li>
							</OverlayTrigger>
						) : null}

						<OverlayTrigger
							placement="top"
							overlay={
								this.state.hackRecordFeature ? (
									!this.state.permissibleActionsIAM['hack-record-result'] ? (
										<Tooltip id="top">You don't have permission to access</Tooltip>
									) : (
										<Tooltip id="top" className="d-none" />
									)
								) : (
									<Tooltip id="top">Upgrade your plan</Tooltip>
								)
							}
						>
							<li
								className={
									this.state.activeClass === "hackrecord" ? "active" : ""
								}
							>
								{(this.state.hackRecordFeature && this.state.permissibleActionsIAM['hack-record-result']) ? (
									<Link to="/hackrecord">
										<PiDetective className="icon" />
										<span>Hack Record</span>
									</Link>
								) : (
									<Link
										to={"#"}
										style={{
											cursor: "not-allowed",
											opacity: 0.6,
											textDecoration: "none"
										}}
										onClick={(e) => {
											e.preventDefault();
										}}
									>
										<PiHeartbeat className="icon" />
										<span>Hack Record</span>
									</Link>
								)}
							</li>
						</OverlayTrigger>



						<span className="sbheading">Workspace</span>

						<Accordion
							className="sub-menu"
							defaultActiveKey={
								this.state.activeClass === "department" ? "0" :
									this.state.activeClass === "reports" ? "1" :
										this.state.activeClass === "iam" ? "2" :
											this.state.activeClass === "schedule" ? "4" :
												this.state.activeClass === "settings" ? "3" : "-1"
							}
						>
							<Accordion.Toggle
								eventKey="4"
								onClick={(e) =>
									this.setState({
										activeCollapse6: !this.state.activeCollapse6,
										activeCollapse1: false,
										activeCollapse2: false,
										activeCollapse3: false,
										activeCollapse4: false,
										activeCollapse5: false,
									})
								}
								className={
									this.state.activeCollapse6
										? "activeCollapse"
										: "deactiveCollapse"
								}
							>
								<PiCalendarBlank className="icon" />
								<span>
									Users & Groups
									<NavigateNextSharpIcon className="down-arrow" />
								</span>
							</Accordion.Toggle>
							<Accordion.Collapse className="accordion-li" eventKey="4">
								<OverlayTrigger
									placement="top"
									overlay={
										!this.state.permissibleActionsIAM['user-and-department-read']
											? (<Tooltip id="top">You don't have permission to access</Tooltip>)
											: (<Tooltip id="top" className="d-none"></Tooltip>)
									}
								>
									<div style={{ cursor: this.state.permissibleActionsIAM['user-and-department-read'] ? "pointer" : "not-allowed" }}>
										<li
											className={this.state.activeSubClass === "user" ? "active" : ""}
										>
											<Link to={this.state.permissibleActionsIAM['user-and-department-read'] ? "/department/user" : "#"}>
												<span>
													<PiUsers className="icon" />
													Users
												</span>
											</Link>
										</li>
										<li
											className={
												this.state.activeSubClass === "groups" ? "active" : ""
											}
										>
											<Link to={this.state.permissibleActionsIAM['user-and-department-read'] ? "/department/groups" : "#"}>
												<span>
													<PiTreeStructure className="icon" />
													Groups
												</span>
											</Link>
										</li>
									</div>
								</OverlayTrigger>

							</Accordion.Collapse>
						</Accordion>
						{this.state.userType === "root" &&
							<li
								className={this.state.activeClass === "iam" ? "active" : ""}
							>
								<Link to="/iam">
									<PiUserList className="icon"></PiUserList>
									<span>IAM</span>
								</Link>
							</li>
						}

						{this.state.billingType === "AppSumo" ?
							<li
								className={this.state.activeClass === "billing" ? "active" : ""}
							>
								<Link to="/billing">
									<ReceiptSharpIcon className="icon"></ReceiptSharpIcon>
									<span>Billings</span>
								</Link>
							</li>
							: null}
						{!this.isNewClient && <li
							className={
								this.state.activeClass === "integration" ? "active" : ""
							}
						>
							<Link to="/integration">
								<PiLineSegments className="icon" />
								<span>Integrations</span>
							</Link>
						</li>}

						
					</ul>
					<div className={`pu_wrapper text-center ${this.props.sidebar ? "" : "pu_wrapper--compact"}`}>
						{this.props.sidebar ? (
							<button
								type="button"
								className="btn btn-primary product-tour-btn"
								onClick={() => this.setState({ showProductUpdateModal: true })}
							>
								<PiInfo style={{ marginTop: "-3px" }} /> New Updates
								<sup className="new_sup">4</sup>
							</button>
						) : (
							<OverlayTrigger
								placement="right"
								overlay={<Tooltip id="product-updates-tip">New Updates</Tooltip>}
							>
								<button
									type="button"
									className="btn btn-primary product-tour-btn product-tour-btn--compact"
									onClick={() => this.setState({ showProductUpdateModal: true })}
									aria-label="New Updates"
								>
									<PiInfo />
									<em className="product-tour-count">4</em>
								</button>
							</OverlayTrigger>
						)}
					</div>
					<ProductUpdateModal
						show={this.state.showProductUpdateModal}
						onHide={() => this.setState({ showProductUpdateModal: false })}
					/>
				</div>
				
				{ this.state.showModal && (
				<LaunchModal
					showModal={this.state.showModal}
					showHandle={this.showHandle}
					nextPath={this.props.nextPath}
				></LaunchModal>
				)}
			</div>
		);
	}
}